module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d14e83"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e1481"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c3_r1#d7e1",
      "id": "d6e1"
    }
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e1531"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c4_r1#d7e2",
      "id": "d6e2"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e14871"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c5_r1#d7e3",
      "id": "d6e3"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e32561"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c6_r1#d7e4",
      "id": "d6e4"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e41031"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c7_r1#d7e5",
      "id": "d6e5"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e53571"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c8_r1#d7e6",
      "id": "d6e6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e58791"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c9_r1#d7e7",
      "id": "d6e7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e64511"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c10_r1#d7e8",
      "id": "d6e8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e83601"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c11_r1#d7e9",
      "id": "d6e9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e101351"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c12_r1#d7e10",
      "id": "d6e10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e113441"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c13_r1#d7e11",
      "id": "d6e11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e124621"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c14_r1#d7e12",
      "id": "d6e12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e140431"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c15_r1#d7e13",
      "id": "d6e13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e149571"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c16_r1#d7e14",
      "id": "d6e14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e158361"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c17_r1#d7e15",
      "id": "d6e15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e164501"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c18_r1#d7e16",
      "id": "d6e16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e190481"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c19_r1#d7e17",
      "id": "d6e17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e208071"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c20_r1#d7e18",
      "id": "d6e18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e213331"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c21_r1#d7e19",
      "id": "d6e19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e220901"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c22_r1#d7e20",
      "id": "d6e20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e231891"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c23_r1#d7e21",
      "id": "d6e21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e261161"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c24_r1#d7e22",
      "id": "d6e22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e290011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c25_r1#d7e23",
      "id": "d6e23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e293851"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c26_r1#d7e24",
      "id": "d6e24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e302581"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c27_r1#d7e25",
      "id": "d6e25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e313641"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c28_r1#d7e26",
      "id": "d6e26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e325401"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c29_r1#d7e27",
      "id": "d6e27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e328371"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c30_r1#d7e28",
      "id": "d6e28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e337631"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c31_r1#d7e29",
      "id": "d6e29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e347341"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c32_r1#d7e30",
      "id": "d6e30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e367021"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c33_r1#d7e31",
      "id": "d6e31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e367071"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c34_r1#d7e32",
      "id": "d6e32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e375841"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c35_r1#d7e33",
      "id": "d6e33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e396691"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c36_r1#d7e34",
      "id": "d6e34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e409471"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c37_r1#d7e35",
      "id": "d6e35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e416551"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c38_r1#d7e36",
      "id": "d6e36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e424941"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c39_r1#d7e37",
      "id": "d6e37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e448241"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c40_r1#d7e38",
      "id": "d6e38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e459291"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c41_r1#d7e39",
      "id": "d6e39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e477961"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c42_r1#d7e40",
      "id": "d6e40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e490351"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c43_r1#d7e41",
      "id": "d6e41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e490401"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c44_r1#d7e42",
      "id": "d6e42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e494701"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c45_r1#d7e43",
      "id": "d6e43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 40")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e498401"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c46_r1#d7e44",
      "id": "d6e44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 41")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e504381"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c47_r1#d7e45",
      "id": "d6e45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 42")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e527611"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c48_r1#d7e46",
      "id": "d6e46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 43")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e531591"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_c49_r1#d7e47",
      "id": "d6e47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4104a709","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lodi_9781937084325_epub_toc_r1.vue
// module id = 63
// module chunks = 0